import { getAddress } from "@/src/lib/getAddress"
import { erc20ABI, readContract } from "@wagmi/core"

const GetERC20Allowance = async (
  address: `0x${string}`,
  buyer: `0x${string}`,
  chainId: number
) => {
  const productsModuleAddress = getAddress(chainId, "ProductsModule")

  try {
    return await readContract({
      address,
      abi: erc20ABI,
      functionName: "allowance",
      args: [buyer, productsModuleAddress]
    })
  } catch (err) {
    throw err
  }
}

export default GetERC20Allowance
